import React, { useEffect, useState } from "react";
import {
  Box,
  Modal,
  Typography,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { getGrupos, deleteGrupo, getGrupoById } from "../../api/grupoApi";
import { buscaGrupo, Empresa, todoGrupo } from "../../types/grupo";
import Tabela from "../../components/Tabela";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Grupo: React.FC = () => {
  const [grupos, setGrupos] = useState<buscaGrupo[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [grupoSelecionado, setGrupoSelecionado] = useState<todoGrupo | null>(
    null
  );
  const [modalAberta, setModalAberta] = useState<boolean>(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchGrupos = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          throw new Error("Token não encontrado");
        }
        const gruposData = await getGrupos(token);
        setGrupos(gruposData);
      } catch (error) {
        toast.error("Erro ao buscar grupos!");
        console.error("Erro ao buscar grupos:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchGrupos();
  }, []);

  const handleAddGrupo = () => {
    navigate("/adicionarGrupo");
  };

  const handleEditGrupo = (id: string) => {
    navigate(`/editarGrupo/${id}`);
  };

  const handleDeleteGrupo = async (id: string) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("Token não encontrado");
      }
      await deleteGrupo(token, id);
      setGrupos(grupos.filter((grupo) => grupo.id !== Number(id)));
      toast.success("Grupo excluído com sucesso!");
    } catch (error) {
      toast.error("Erro ao excluir grupo!");
      console.error("Erro ao excluir grupo:", error);
    }
  };

  const handleViewGrupo = async (id: string) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("Token não encontrado");
      }
      const grupoData = await getGrupoById(token, id);
      setGrupoSelecionado(grupoData);
      setModalAberta(true);
    } catch (error) {
      toast.error("Erro ao carregar detalhes do grupo!");
      console.error("Erro ao carregar detalhes do grupo:", error);
      throw error;
    }
  };

  const handleFecharModal = () => {
    setModalAberta(false);
  };

  const handleVincularEmpresa = () => {
    if (grupoSelecionado) {
      navigate("/adicionarEmpresa", {
        state: { grupoId: grupoSelecionado.id },
      });
    }
  };

  const colunas = [
    { id: "id", label: "ID" },
    { id: "nome_grupo", label: "Nome do Grupo" },
    { id: "created_at", label: "Data de Criação" },
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Tabela
        titulo="Grupos"
        colunas={colunas}
        dados={grupos}
        onAdd={handleAddGrupo}
        onEdit={handleEditGrupo}
        onView={handleViewGrupo}
        onDelete={handleDeleteGrupo}
        loading={loading}
        showVisibilityIcon={true}
      />
      <Modal open={modalAberta} onClose={handleFecharModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            minWidth: "50%",
          }}
        >
          {grupoSelecionado && (
            <>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 3,
                  flexWrap: "wrap",
                }}
              >
                <Typography variant="h6">Empresa Cadastrada</Typography>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  onClick={handleVincularEmpresa}
                >
                  Vincular Empresa
                </Button>
              </Box>
              {grupoSelecionado.empresas.length > 0 ? (
                <TableContainer component={Box} sx={{ maxHeight: 400 }}>
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell>ID</TableCell>
                        <TableCell>CNPJ</TableCell>
                        <TableCell>Nome</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {grupoSelecionado.empresas.map((empresa: Empresa) => (
                        <TableRow key={empresa.id}>
                          <TableCell>{empresa.id}</TableCell>
                          <TableCell>{empresa.cnpj_empresa}</TableCell>
                          <TableCell>{empresa.nome_empresa}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : (
                <Typography variant="body1" mt={2}>
                  Nenhuma empresa cadastrada.
                </Typography>
              )}
              <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  onClick={handleFecharModal}
                >
                  Fechar
                </Button>
              </Box>
            </>
          )}
        </Box>
      </Modal>
    </Box>
  );
};

export default Grupo;
